export default __webpack_public_path__ + "static/media/1.5d5b9b6e.png";